import React from 'react'

const NotFoundPaga = () => {
  return (
    <div>PagaNotFound</div>
  )
}

export default NotFoundPaga